export default __webpack_public_path__ + "static/media/music.7a2157ca.png";